module.exports = __webpack_public_path__ + "static/media/Final 1  copy 2.f992556d.png";